module.exports = __webpack_public_path__ + "static/media/privacidad.f35d930e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/privacidad.jpg
// module id = 611
// module chunks = 0